import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-learn',
  templateUrl: './learn.component.html',
  styleUrls: ['./learn.component.scss']
})
export class LearnComponent implements OnInit {

  public learnState: String = "how";

  constructor(private route: ActivatedRoute, private AuthenticationService: AuthenticationService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.learnState = params.section;
    });
  }

}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/learn/learn.component.ts